import { CAST_AI } from '@cast/constants';

import { EnablingStepLayout } from './EnablingStepLayout';
import {
  WhatHappensNextBullet,
  WhatHappensNextSection,
} from './WhatHappensNextSection';

type Props = {
  onClose: () => void;
  onBack: () => void;
};

export const EnablingFeaturesStep = ({ onClose, onBack }: Props) => {
  return (
    <EnablingStepLayout
      onBack={onBack}
      onClose={onClose}
      testId="enabling-features-step"
      title={`Enabling ${CAST_AI} features`}
    >
      <WhatHappensNextSection>
        <WhatHappensNextBullet>
          {CAST_AI} components will be deployed to your cluster
        </WhatHappensNextBullet>
        <WhatHappensNextBullet>
          Data collection will begin within 5 minutes
        </WhatHappensNextBullet>
        <WhatHappensNextBullet>
          Product recommendations will appear in 15-30 minutes
        </WhatHappensNextBullet>
      </WhatHappensNextSection>
    </EnablingStepLayout>
  );
};
